export default __webpack_public_path__ + "static/media/loader.71702598.gif";